/**
 * Mantem o numero do carrinho em dia em dois casos que o tema deixa passar.
 *
 * 1. QUANTIDADE APARADA PELO ESTOQUE
 *
 * Pedindo 5 de um produto que so tem 1, a Shopify responde 422 —
 * "Only 1 item was added to your cart due to availability." — E MESMO ASSIM
 * adiciona a unidade que tinha. O tema le o 422 como "nada entrou": mostra o
 * aviso e nao dispara o `cartcount:update` que atualiza o numero. O carrinho
 * tem um item, o cabecalho continua zerado, e so um F5 acerta os dois.
 *
 * 2. VOLTAR DO NAVEGADOR
 *
 * Saindo do carrinho pelo botao voltar, a pagina volta do bfcache — a memoria
 * de paginas do navegador — exatamente como estava, numero velho incluido.
 * Nenhum script roda de novo nesse retorno, so o evento `pageshow`.
 *
 * COMO CORRIGE, E POR QUE ASSIM
 *
 * Fica de fora do caminho: NAO envolve o `window.fetch`.
 *
 * A primeira versao disto trocava o `fetch` global por uma funcao que avisava
 * depois de cada chamada. Funcionava, mas punha um intermediario no meio de
 * TODA requisicao da pagina — inclusive as do "Buy with Shop", que e um
 * componente da propria Shopify. Nao vale arriscar o botao de pagamento para
 * acertar um numero no cabecalho.
 *
 * Aqui a deteccao e passiva: o `PerformanceObserver` avisa quando uma
 * requisicao ao carrinho ACONTECEU, sem interceptar nada. Dai le `/cart.js` e
 * dispara o MESMO evento que o tema ja escuta.
 */
(() => {
  const ROTAS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  let ultimoAviso = 0;

  const avisar = async () => {
    // varias chamadas seguidas (mudar quantidade rapido) viram um aviso so
    const agora = Date.now();
    if (agora - ultimoAviso < 250) return;
    ultimoAviso = agora;

    try {
      const r = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, {
        headers: { 'Content-Type': 'application/json' },
        // sem cache: e justamente o valor recem-mudado que se quer ler
        cache: 'no-store',
      });
      if (!r.ok) return;
      const carrinho = await r.json();
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: carrinho }));
    } catch {
      // carrinho indisponivel nao e motivo para quebrar a pagina
    }
  };

  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((lista) => {
        for (const entrada of lista.getEntries()) {
          if (ROTAS.test(entrada.name)) {
            avisar();
            break;
          }
        }
      }).observe({ type: 'resource', buffered: true });
    } catch {
      // navegador sem suporte: o numero volta a depender do tema, e so isso
    }
  }

  // O retorno pelo bfcache: `persisted` diz que a pagina veio da memoria.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) avisar();
  });
})();
